import Content from '@components/Login/Content';
import SignInCard from '@components/Login/SignInCard';
import { ROUTE_PATHS } from '@constants/routes';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import { useAppSelector } from '@store/hooks';
import AppTheme from '@theme/theme';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const authState = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (authState.isAuthenticated) navigate(ROUTE_PATHS.HOME);
  }, [authState, navigate]);

  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            marginTop: 'max(40px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              zIndex: 0,
              inset: 0,
              background:
                'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
              backgroundRepeat: 'no-repeat',
            },
          },
        ]}
      >
        <Stack
          direction={{ xs: 'column-reverse', md: 'row' }}
          sx={{
            justifyContent: 'center',
            gap: { xs: 6, sm: 12 },
            p: 2,
            mx: 'auto',
            zIndex: 2,
          }}
        >
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            sx={{
              justifyContent: 'center',
              gap: { xs: 6, sm: 12 },
              p: { xs: 2, sm: 4 },
              m: 'auto',
            }}
          >
            <Content />
            <SignInCard />
          </Stack>
        </Stack>
      </Stack>
    </AppTheme>
  );
};

export default LoginPage;
